<div class="app-version-panel-wrapper">
  <a class="version-logo-link" [href]="officialApizWebSiteUrl" target="_blank">
    <img class="version-logo" src="assets/iupics/img/logo-apiz.svg" alt="Apiz" />
  </a>
  <div class="version-description">
    <span class="versionName">© APIZ Advanced ERP Solutions</span>
    <span class="versionName" data-cy="app-version-number">— {{ version }}</span>
  </div>
</div>
